import type { ProjectItem, Workspace, WorkspaceItem } from '../types'

const isOwn = ({ sharedBy }: ProjectItem) => sharedBy === null

const isOwnActive = (project: ProjectItem) =>
  isOwn(project) && !project.archived

// Counters never show projects shared with the user, and never show archived
// ones outside the archive folder — the one place countOwnProjects is used.
export const countOwnProjects = ({ projects }: WorkspaceItem) =>
  projects.filter(isOwn).length

export const countOwnActiveProjects = ({ projects }: WorkspaceItem) =>
  projects.filter(isOwnActive).length

export const countWorkspaceProjects = ({ folders }: Workspace) =>
  folders.reduce((total, folder) => total + countOwnActiveProjects(folder), 0)
